<template>
  <div class="homePage">
    <!-- PC端布局 -->
    <div class="latest-news-container pc-layout">
      <!-- 左侧公告列表 -->
      <div class="news-list-section">
        <div class="list-header">
          <h3>{{ $t("common.latestNews.latestAnnouncement") }}</h3>
        </div>
        <ul class="news-list">
          <li
            v-for="(item, index) in latestNews"
            :key="index"
            :class="{ active: currentIndex === index }"
            @click="selectNews(index)"
          >
            <span class="news-title">{{ item.title }}</span>
          </li>
        </ul>
      </div>

      <!-- 右侧公告详情 -->
      <div class="news-detail-section">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <span class="breadcrumb-item" @click="goToHome">{{ $t("common.latestNews.home") }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item clickable" @click="goToAllNews"
            >{{ $t("common.latestNews.allAnnouncements") }}</span
          >
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item">{{ $t("common.latestNews.latestAnnouncement") }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-item current">{{
            currentNews.title || $t("common.latestNews.announcementDetail")
          }}</span>
        </div>

        <!-- 公告详情内容 -->
        <div class="news-content">
          <h2 class="news-title-detail">{{ currentNews.title }}</h2>
          <div class="news-summary" v-html="currentNews.content"></div>
        </div>
      </div>
    </div>

    <!-- 移动端布局 -->
    <div class="mobile-layout">
      <!-- 顶部导航栏 -->
      <div class="mobile-header">
        <span class="back-btn" @click="goToAllNews">← {{ $t("common.latestNews.allAnnouncements") }}</span>
        <h3>{{ $t("common.latestNews.announcementDetail") }}</h3>
      </div>

      <!-- 公告标题 -->
      <div class="mobile-title-section">
        <h2 class="mobile-title">{{ currentNews.title }}</h2>
      </div>

      <!-- 公告内容 -->
      <div class="mobile-content">
        <div class="mobile-summary" v-html="currentNews.content"></div>
      </div>

      <!-- 底部切换按钮 -->
      <div class="mobile-footer">
        <button
          class="switch-btn prev-btn"
          @click="prevNews"
          :disabled="currentIndex === 0"
        >
          {{ $t("common.latestNews.previousArticle") }}
        </button>
        <button
          class="switch-btn next-btn"
          @click="nextNews"
          :disabled="currentIndex === latestNews.length - 1"
        >
          {{ $t("common.latestNews.nextArticle") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getLatestNews } from "@/api/user";

export default {
  data() {
    return {
      latestNews: [], // 最新公告
      currentIndex: 0, // 当前选中的公告索引
    };
  },
  computed: {
    // 当前选中的公告
    currentNews() {
      if (this.latestNews.length > 0 && this.currentIndex >= 0) {
        return this.latestNews[this.currentIndex] || {};
      }
      return {};
    },
  },
  methods: {
    // 选择公告
    selectNews(index) {
      this.currentIndex = index;
    },
    goToHome() {
      this.$router.push("/");
    },
    goToAllNews() {
      this.$router.push("/module/allNews");
    },
    // 上一篇
    prevNews() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    // 下一篇
    nextNews() {
      if (this.currentIndex < this.latestNews.length - 1) {
        this.currentIndex++;
      }
    },
  },
  async mounted() {
    // 获取最新公告
    await getLatestNews().then((res) => {
      if (res.code === 200) {
        this.latestNews = res.data;
        console.log("this.latestNews", this.latestNews);

        // 检查路由中是否有id参数
        const id = this.$route.query.id || this.$route.params.id;
        if (id) {
          // 查找与id匹配的公告索引
          const index = this.latestNews.findIndex(
            (item) => item.id === id || item.id === Number(id)
          );
          if (index !== -1) {
            this.currentIndex = index;
          }
        }
      }
    });
  },
};
</script>

<style scoped>
</style>

<style lang="scss" scoped>
.homePage {
  min-height: calc(100vh - 60px);
  background-color: #f5f7fa;
}

// ==================== PC端样式 ====================
.pc-layout {
  display: flex;
  padding: 20px 140px;
  gap: 20px;
  max-width: 100%;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
}

// 左侧公告列表
.news-list-section {
  width: 300px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .list-header {
    padding: 20px;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      margin: 0;
      font-size: 18px;
      color: #333;
      font-weight: 600;
    }
  }

  .news-list {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: calc(100vh - 200px);
    overflow-y: auto;

    li {
      padding: 15px 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      border-left: 3px solid transparent;

      &:hover {
        background-color: #f0f7ff;
        border-left-color: #409eff;
      }

      &.active {
        background-color: #e6f4ff;
        border-left-color: #409eff;

        .news-title {
          color: #409eff;
          font-weight: 600;
        }
      }

      .news-title {
        display: block;
        font-size: 14px;
        color: #666;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

// 右侧公告详情
.news-detail-section {
  flex: 1;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px;
  display: flex;
  flex-direction: column;
}

// 面包屑导航
.breadcrumb {
  padding: 15px 0;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 20px;
  font-size: 14px;

  .breadcrumb-item {
    color: #666;

    &.clickable {
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: #409eff;
      }
    }

    &.current {
      color: #409eff;
      font-weight: 500;
    }
  }

  .breadcrumb-separator {
    margin: 0 8px;
    color: #999;
  }
}

// 公告内容
.news-content {
  flex: 1;
  overflow-y: auto;

  .news-title-detail {
    font-size: 24px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
    line-height: 1.4;
  }

  .news-summary {
    font-size: 15px;
    color: #666;
    line-height: 1.8;

    ::v-deep {
      p {
        margin: 10px 0;
      }

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
      }

      a {
        color: #409eff;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }

      ul,
      ol {
        padding-left: 20px;
        margin: 10px 0;
      }

      li {
        margin: 5px 0;
      }
    }
  }
}

// ==================== 移动端样式 ====================
.mobile-layout {
  display: none;
  min-height: calc(100vh - 50px);
  background-color: #f5f7fa;
}

// 移动端顶部导航
.mobile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  position: sticky;
  top: 0;
  z-index: 10;

  .back-btn {
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
    margin-right: 15px;

    &:active {
      opacity: 0.7;
    }
  }

  h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}

// 移动端标题区域
.mobile-title-section {
  background: #ffffff;
  padding: 20px 15px;
  border-bottom: 1px solid #f0f0f0;

  .mobile-title {
    margin: 0;
    font-size: 18px;
    color: #333;
    font-weight: 600;
    line-height: 1.5;
  }
}

// 移动端内容区域
.mobile-content {
  background: #ffffff;
  padding: 20px 15px;
  min-height: calc(100vh - 250px);

  .mobile-summary {
    font-size: 15px;
    color: #666;
    line-height: 1.8;

    ::v-deep {
      p {
        margin: 10px 0;
      }

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        margin: 10px 0;
      }

      a {
        color: #409eff;
        text-decoration: none;

        &:active {
          opacity: 0.7;
        }
      }

      ul,
      ol {
        padding-left: 20px;
        margin: 10px 0;
      }

      li {
        margin: 5px 0;
      }
    }
  }
}

// 移动端底部按钮
.mobile-footer {
  display: flex;
  gap: 10px;
  padding: 15px;
  background: #ffffff;
  border-top: 1px solid #e8e8e8;
  position: sticky;
  bottom: 0;

  .switch-btn {
    flex: 1;
    padding: 12px;
    border: 1px solid #409eff;
    background: #ffffff;
    color: #409eff;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:active:not(:disabled) {
      background: #409eff;
      color: #ffffff;
    }

    &:disabled {
      border-color: #dcdfe6;
      color: #c0c4cc;
      cursor: not-allowed;
      background: #f5f7fa;
    }

    &.next-btn {
      background: #409eff;
      color: #ffffff;

      &:active:not(:disabled) {
        background: #66b1ff;
      }

      &:disabled {
        background: #a0cfff;
        border-color: #a0cfff;
      }
    }
  }
}

// ==================== 响应式媒体查询 ====================

// 平板端
@media screen and (max-width: 1024px) {
  .pc-layout {
    padding: 20px 60px;
  }

  .news-list-section {
    width: 260px;
  }
}

// 移动端 - 隐藏PC布局，显示移动布局
@media screen and (max-width: 768px) {
  .pc-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }

  .homePage {
    min-height: calc(100vh - 50px);
  }
}
</style>
